<template>
  <div class="app-settings" v-loading.fullscreen.lock="loading" v-loading="dataLoading">
    <el-card class="settings-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>App LLM Settings</span>
        <el-button class="top-botton" type="primary" size="small" icon="el-icon-check"
          @click="setSettings">Save</el-button>
        <el-button class="top-botton top-next-botton" type="" size="small" icon="el-icon-refresh"
          @click="fetchSettings">Fresh</el-button>
      </div>
      <el-form ref="form" :model="form" :rules="rules" size="mini" label-width="140px">
        <el-form-item label="Type" prop="type">
          <el-select v-model="form.type" placeholder="Please select type" style="width: 100%;">
            <el-option label="openai" value="openai"></el-option>
            <el-option label="gemini" value="gemini"></el-option>
            <el-option label="aliyun" value="aliyun"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Endpoint" prop="endpoint">
          <el-input v-model="form.endpoint" placeholder="Please input endpoint"></el-input>
        </el-form-item>
        <el-form-item label="API Key" prop="apiKey">
          <el-input v-model="form.apiKey" placeholder="Please input API Key" show-password></el-input>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { fetchAppSettings, setAppSettings } from "@/api/admin";

export default {
  data() {
    return {
      loading: false,
      dataLoading: false,
      form: {
        type: "",
        endpoint: "",
        apiKey: "",
      },
      rules: {
        type: [{ required: true, message: 'Please select type', trigger: 'change' }],
        endpoint: [{ required: true, message: 'Please input endpoint', trigger: 'blur' }],
        apiKey: [{ required: true, message: 'Please input API Key', trigger: 'blur' }],
      }
    };
  },
  mounted() {
    this.active();
  },
  methods: {
    active() {
      this.fetchSettings();
    },
    clearForm() {
      this.form = {
        type: "",
        endpoint: "",
        apiKey: "",
      };
    },
    fetchSettings() {
      this.dataLoading = true;
      fetchAppSettings()
        .then((response) => {
          if (response.success && response.result) {
            this.form = {
              type: response.result.type || "",
              endpoint: response.result.endpoint || "",
              apiKey: response.result.apiKey || "",
            };
          } else {
            this.clearForm();
          }
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },
    setSettings() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.dataLoading = true;
        setAppSettings(this.form)
          .then((response) => {
            if (response.success) {
              this.$notify({
                title: "Update successful",
                type: "success",
              });
              this.fetchSettings();
            }
          })
          .finally(() => {
            this.dataLoading = false;
          });
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.app-settings {
  .settings-card {
    margin-bottom: 10px;

    .top-botton {
      float: right;
      margin-top: -8px;
      margin-bottom: -8px
    }

    .top-next-botton {
      margin-right: 10px;
    }
  }
}
</style>
